import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'newsfeed'

export const [LIST_NEWSFEED_REQUEST, LIST_NEWSFEED_SUCCESS, LIST_NEWSFEED_FAILURE] =
  createRequestTypes(prefix, 'LIST_NEWSFEED')

export const listNewsfeed = createAction((params: object) => ({
  type: [LIST_NEWSFEED_REQUEST, LIST_NEWSFEED_SUCCESS, LIST_NEWSFEED_FAILURE],
  promise: (api: IApi) => api.newsfeed.listNewsfeed(params),
  params,
}))

export const [
  LIST_HEADLINE_REPLIES_REQUEST,
  LIST_HEADLINE_REPLIES_SUCCESS,
  LIST_HEADLINE_REPLIES_FAILURE,
] = createRequestTypes(prefix, 'LIST_HEADLINE_REPLIES')

export const listHeadlineReplies = createAction((id: string, params: object) => ({
  type: [
    LIST_HEADLINE_REPLIES_REQUEST,
    LIST_HEADLINE_REPLIES_SUCCESS,
    LIST_HEADLINE_REPLIES_FAILURE,
  ],
  promise: (api: IApi) => api.notes.list(id, params),
  id,
  params,
}))

export const [EXPORT_NEWSFEED_REQUEST, EXPORT_NEWSFEED_SUCCESS, EXPORT_NEWSFEED_FAILURE] =
  createRequestTypes(prefix, 'EXPORT_NEWSFEED')

export const exportNewsfeed = createAction((data: object = {}) => ({
  type: [EXPORT_NEWSFEED_REQUEST, EXPORT_NEWSFEED_SUCCESS, EXPORT_NEWSFEED_FAILURE],
  promise: (api: IApi) => api.newsfeed.listNewsfeed({ ...data, isFile: true }),
  params: data,
}))

export const [SHOW_NEWSFEED_REQUEST, SHOW_NEWSFEED_SUCCESS, SHOW_NEWSFEED_FAILURE] =
  createRequestTypes(prefix, 'SHOW_NEWSFEED')

export const showNewsfeed = createAction((id: string, params?: object) => ({
  type: [SHOW_NEWSFEED_REQUEST, SHOW_NEWSFEED_SUCCESS, SHOW_NEWSFEED_FAILURE],
  promise: (api: IApi) => api.newsfeed.showNewsfeed(id),
  params,
}))

export const [DELETE_NEWSFEED_REQUEST, DELETE_NEWSFEED_SUCCESS, DELETE_NEWSFEED_FAILURE] =
  createRequestTypes(prefix, 'DELETE_NEWSFEED')

export const deleteNews = createAction((id: string, params?: object) => ({
  type: [DELETE_NEWSFEED_REQUEST, DELETE_NEWSFEED_SUCCESS, DELETE_NEWSFEED_FAILURE],
  promise: (api: IApi) => api.newsfeed.deleteNews(id),
  params,
}))

export const [
  LIST_CLIENT_NEWSFEED_REQUEST,
  LIST_CLIENT_NEWSFEED_SUCCESS,
  LIST_CLIENT_NEWSFEED_FAILURE,
] = createRequestTypes(prefix, 'LIST_CLIENT_NEWSFEED')

export const listClientNewsfeed = createAction(() => ({
  type: [LIST_CLIENT_NEWSFEED_REQUEST, LIST_CLIENT_NEWSFEED_SUCCESS, LIST_CLIENT_NEWSFEED_FAILURE],
  promise: (api: IApi) => api.newsfeed.listClientNewsfeed(),
}))

export const [LIST_BRAND_OPTIONS_REQUEST, LIST_BRAND_OPTIONS_SUCCESS, LIST_BRAND_OPTIONS_FAILURE] =
  createRequestTypes(prefix, 'LIST_BRAND_OPTIONS')

export const listBrandOptions = createAction((params: object) => ({
  type: [LIST_BRAND_OPTIONS_REQUEST, LIST_BRAND_OPTIONS_SUCCESS, LIST_BRAND_OPTIONS_FAILURE],
  promise: (api: IApi) => api.newsfeed.listBrandOptions(params),
}))

export const [UPDATE_NEWSFEED_REQUEST, UPDATE_NEWSFEED_SUCCESS, UPDATE_NEWSFEED_FAILURE] =
  createRequestTypes(prefix, 'UPDATE_NEWSFEED')

export const updateNewsfeed = createAction((id: string, params: object) => ({
  type: [UPDATE_NEWSFEED_REQUEST, UPDATE_NEWSFEED_SUCCESS, UPDATE_NEWSFEED_FAILURE],
  promise: (api: IApi) => api.newsfeed.updateNewsfeed(id, params),
  params,
}))

export const SELECT_NEWSLETTER_HEADLINES = createRequestTypes(prefix, 'SELECT_NEWSLETTER_HEADLINES')

export const selectNewsletterHeadlines = createAction((data: object) => ({
  type: SELECT_NEWSLETTER_HEADLINES,
  promise: (api: IApi) => api.newsfeed.selectNewsletterHeadlines(data),
}))

export const [REPORT_WRONG_MATCH_REQUEST, REPORT_WRONG_MATCH_SUCCESS, REPORT_WRONG_MATCH_FAILURE] =
  createRequestTypes(prefix, 'REPORT_WRONG_MATCH')

export const reportWrongMatch = createAction((newsfeedId: string) => ({
  type: [REPORT_WRONG_MATCH_REQUEST, REPORT_WRONG_MATCH_SUCCESS, REPORT_WRONG_MATCH_FAILURE],
  promise: (api: IApi) => api.newsfeed.reportWrongMatch(newsfeedId),
}))

export const [CREATE_LEAD_REQUEST, CREATE_LEAD_SUCCESS, CREATE_LEAD_FAILURE] = createRequestTypes(
  prefix,
  'CREATE_LEAD',
)

export const createLead = createAction((data: object) => ({
  type: [CREATE_LEAD_REQUEST, CREATE_LEAD_SUCCESS, CREATE_LEAD_FAILURE],
  promise: (api: IApi) => api.newsfeed.createLead(data),
}))
